import React from 'react';
import styled from 'styled-components';

const ComponentColumnContainer = styled.div`
    position: relative;
    padding: 8px;
    width: 50%;

    & + & {
        padding-left: 0;
    }
`;

type TProps = {
    children: JSX.Element[];
};

const ComponentColumn = ({ children }: TProps): JSX.Element => {
    return <ComponentColumnContainer>{children}</ComponentColumnContainer>;
};

export default ComponentColumn;
